import { TeamType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const teamTypeDictionary = createSimpleDictionary([
    { id: TeamType.Club, name: 'dictionaries.teamType.club' },
    { id: TeamType.National, name: 'dictionaries.teamType.national' },
    { id: TeamType.Fantasy, name: 'dictionaries.teamType.fantasy' },
]);
